import React, { useState, useEffect } from 'react';
import ReactECharts from 'echarts-for-react';

import { commonOptions } from 'data/eco-environmental-survey';
import { GRAPH_HEIGHT, GRAPH_COLOR } from 'data/common';

function ScaleComparasionBarGraph(props) {
  const { active, data, item } = props;
  const { title, col, unit, termList } = item;
  const [xAxis, setXAxis] = useState([]);
  const [series, setSeries] = useState([]);
  const height = GRAPH_HEIGHT.default;

  const isFetchingSeries = series.length === 0;

  const handleFilter = (col) => {
    const safeData = data && typeof data === 'object' ? data : {};
    const filterResult = Object.fromEntries(
      Object.entries(safeData).map(([regionKey, rows]) => {
        const matchYear =
          Array.isArray(rows) && rows.length > 0
            ? rows.find((item) => item && item['年份'] === active?.year)
            : null;

        if (!matchYear) return [regionKey, {}];

        const picked = Object.fromEntries(
          Object.entries(matchYear).filter(([k]) => k.includes(col))
        );

        return [regionKey, picked];
      })
    );

    let termResult = filterResult;
    if (Array.isArray(termList) && termList.length > 0) {
      termResult = Object.fromEntries(
        Object.entries(filterResult).map(([regionKey, obj]) => {
          const src = obj && typeof obj === 'object' ? { ...obj } : {};
          termList.forEach(({ oldKey, newKey }) => {
            if (Object.prototype.hasOwnProperty.call(src, oldKey)) {
              src[newKey] = src[oldKey];
              delete src[oldKey];
            }
          });
          return [regionKey, src];
        })
      );
    }

    return termResult;
  };

  useEffect(() => {
    if (!data || !active?.year) {
      setSeries([]);
      setXAxis([]);
      return;
    }

    const filtered = handleFilter(col);

    const entries = Object.entries(filtered);
    if (entries.length === 0) {
      setSeries([]);
      setXAxis([]);
      return;
    }

    const firstWithData = entries.find(
      ([, v]) => v && Object.keys(v).length > 0
    );
    const xAxisKeys = firstWithData ? Object.keys(firstWithData[1]) : [];

    const seriesArr = entries.map(([regionKey, obj]) => {
      const yVals = xAxisKeys.map((k) => {
        const v = obj?.[k];
        if (v == null || v === '') return 0;
        return Number(String(v).replace(/,/g, '')) || 0;
      });

      return {
        data: yVals,
        type: 'bar',
        name: regionKey,
      };
    });

    setXAxis(xAxisKeys);
    setSeries(seriesArr);
  }, [data, active?.year, col, termList]);

  const option = {
    ...commonOptions,
    color: GRAPH_COLOR.legend.multiple,
    title: { text: `${title}` },
    dataZoom: { show: true },
    tooltip: {
      trigger: 'axis',
      backgroundColor: GRAPH_COLOR.tooltip.background.dark,
      axisPointer: { type: 'shadow', label: { show: true } },
    },
    legend: { top: 'auto', left: 'center', bottom: '12.5%', itemGap: 5 },
    grid: { width: '80%', left: '12.5%', height: '60%' },
    xAxis: { type: 'category', boundaryGap: true, data: xAxis },
    yAxis: { type: 'value', name: `(${unit})` },
    series,
  };

  return (
    <>
      {!isFetchingSeries ? (
        <div className="col-6">
          <ReactECharts
            option={option}
            notMerge={true}
            lazyUpdate={true}
            opts={{ renderer: 'canvas', height: `${height}` }}
            style={{ height }}
          />
        </div>
      ) : (
        <div className="col-6">
          <p className="text-center my-3">目前沒有資料可顯示</p>
        </div>
      )}
    </>
  );
}

export default ScaleComparasionBarGraph;
